import React, { RefObject, createRef } from 'react';
import './CardHoverPoint.scss';
import './CardHoverPoint-media.scss';
import { Moving } from './functions';
import { ICardHoverProps } from '../DeliveryTypes/interfaces';
import {Link} from "../Link/Link";


const CardHoverPoint = ({ name, text, image, icon, link }: ICardHoverProps) => {
  const elCard: RefObject<HTMLAnchorElement> = createRef();
  const elRound: RefObject<HTMLSpanElement> = createRef();

  return (
    <Link
      to={link}
      className="card-hover-point"
      style={!link ? { cursor: 'default' } : {}}
      onMouseEnter={Moving(elCard, elRound)}
      onMouseOut={Moving(elCard, elRound)}
      ref={elCard}
    >
      <div className="card-hover-point__image" style={{ backgroundImage: `url(${image})` }}></div>
      <span ref={elRound} className="card-hover-point__span"></span>
      <h5 className="card-hover-point__name">{name}</h5>
      <p className="card-hover-point__text">{text}</p>
      <img src={icon} className="card-hover-point__icon" alt="icon" />
    </Link>
  );
};

export default CardHoverPoint;
